import { APIResponse } from '../types/index';
import { CreateSocketOptions } from '../types/socket'
import { buildApiUrl, makeHttpRequest } from './index';
import SocketClient from "./SocketClient";


/**
 * Client Configuration Options Interface
 */
export interface ClientOptions {
    baseURL?: string;
    wssURL?: string;
}

/**
 * Core Client Class
 * Provides basic functionality for WebSocket connections and HTTP requests
 */
export class Client {
    protected token: string;
    protected baseURL: string;
    protected wssURL: string;
    constructor(token: string, options: ClientOptions = {}) {
        this.token = token;
        this.baseURL = options.baseURL ?? 'https://api.itick.org';
        this.wssURL = options.wssURL ?? 'wss://api.itick.org';
    }

    /**
     * Send GET request
     */
    protected async _get<T = any>(path: string, params: Record<string, any> = {}): Promise<APIResponse<T>> {
        try {
            const url = buildApiUrl(this.baseURL, path);
            const response = await makeHttpRequest(url, {
                method: 'GET',
                headers: {
                    'accept': 'application/json',
                    'token': this.token
                },
                params,
            });

            if (response.status >= 400) {
                throw new Error(`HTTP Error: ${response.status}`);
            }

            return response.data;
        } catch (error) {
            throw error;
        }
    }

    protected _createSocket(path: string, options?: CreateSocketOptions): SocketClient {
        return new SocketClient(this.token, { wssURL: this.wssURL, wsPath: path, ...options });
    }

}
